export const enum ProjectEvents {
  PROJECT_UNLOCKED = "project_unlocked",
}
